import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getShapeSetOrganisations(shapeSetId, isAllocatedTo = true, excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/organisations';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        shapeSetId,
        isAllocatedTo,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const organisations = response.data.organisations;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_SHAPESET_ALLOCATED_ORGANISATIONS' : 'UPDATE_CURRENT_SHAPESET_UNALLOCATED_ORGANISATIONS';
        dispatch({ type, organisations });
      },
      error => dispatch(APIError(error, 'Error getting currentShapeSet Organisations'))
    );
  }
}

export function addOrganisationToShapeSet(shapeSetId, organisationId) {
  return function(dispatch, getState) {
    const endpoint = '/shapeset/membership/organisation';
    const options = {
      method: "POST",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        shapeSetId,
        organisationId
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getShapeSetOrganisations(shapeSetId, true));
        dispatch(getShapeSetOrganisations(shapeSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error adding organisation to currentShapeSet'))
    );
  }
}

export function removeOrganisationFromShapeSet(shapeSetId, organisation) {
  return function(dispatch, getState) {
    const endpoint = `/shapeset/membership/organisation/${organisation.membershipId}`;
    const options = {
      method: "PUT",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getShapeSetOrganisations(shapeSetId, true));
        dispatch(getShapeSetOrganisations(shapeSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error removing organisation from currentShapeSet'))
    );
  }
}


// WEBPACK FOOTER //
// ./src/actions/shapeSets/organisationCreators.js